import React from "react";
import { useI18n } from "../lib/i18n";

export default function LanguageToggle({ className = "" }) {
  const { lang, setLang } = useI18n();
  return (
    <div className={`inline-flex items-center bg-white border border-[#d9d9d9] rounded-full p-1 ${className}`}>
      <button
        data-testid="lang-pt-btn"
        onClick={() => setLang("pt")}
        className={`px-3 py-1 text-xs font-medium rounded-full transition-all ${
          lang === "pt" ? "bg-[#475569] text-white" : "text-[#747474] hover:text-[#323232]"
        }`}
      >
        PT
      </button>
      <button
        data-testid="lang-en-btn"
        onClick={() => setLang("en")}
        className={`px-3 py-1 text-xs font-medium rounded-full transition-all ${
          lang === "en" ? "bg-[#475569] text-white" : "text-[#747474] hover:text-[#323232]"
        }`}
      >
        EN
      </button>
    </div>
  );
}
